

export const LOGIN = 'auth/LOGIN';
export const LOGOUT = 'auth/LOGOUT';
export const REGISTER = 'auth/REGISTER';
export const GET_PROFILE = 'auth/GET_PROFILE';

export const login = user => ({type:LOGIN, user});
export const logout = () => ({type:LOGOUT});
export const register = user => ({type: REGISTER, user});

const initialUser = {
  user: {}
};

export default function auth(state = initialUser, action){
  switch(action.type){
    case LOGIN:
      return {
        ...state,
        user: action.user
      };
    case LOGOUT:
      return state;
    case GET_PROFILE:
      return {
        ...state,
        user : action.user
      };
    case REGISTER:
      return {
        ...state,
        token: action.token
      }
    default:
      return state;
  }
}
